import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatDialogConfig } from '@angular/material/dialog';

export const DIALOG_CONFIG: MatDialogConfig = {
  width: '25rem',
  maxWidth: '100vw',
  height: 'fit-content',
  panelClass: 'custom-dialog',
  autoFocus: false,
  scrollStrategy: new NoopScrollStrategy(),
};

export const DIALOG_WIDE_CONFIG: MatDialogConfig = {
  width: '50rem',
  maxWidth: '100vw',
  height: 'auto',
  maxHeight: '85vh',
  panelClass: 'custom-dialog',
  autoFocus: false,
  scrollStrategy: new NoopScrollStrategy(),
};

export const DIALOG_WIDER_CONFIG: MatDialogConfig = {
  width: '100rem',
  maxWidth: '100vw',
  height: 'fit-content',
  panelClass: 'custom-dialog',
  autoFocus: false,
  scrollStrategy: new NoopScrollStrategy(),
};

export const DIALOG_WIDER_TALL_CONFIG: MatDialogConfig = {
  width: '100rem',
  maxWidth: '100vw',
  maxHeight: '98dvh',
  height: '98dvh',
  panelClass: 'custom-dialog',
  autoFocus: false,
  scrollStrategy: new NoopScrollStrategy(),
};
